function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = _has;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_has.js
// module id = u+4m
// module chunks = 5